export default __webpack_public_path__ + "static/media/Bilhetagem Real Size.eb3fd31f.svg";